'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	'13_player_rugby': {
		male: 'Joueur de Rugby \xE0 XIII',
		female: 'Joueuse de Rugby \xE0 XIII',
		full: 'Sport > Rugby > Rugby \xE0 XIII'
	},
	'15_player_rugby': {
		male: 'Joueur de Rugby \xE0 XV',
		female: 'Joueuse de Rugby \xE0 XV',
		full: 'Sport > Rugby > Rugby \xE0 XV'
	},
	'7_player_rugby': {
		male: 'Joueur de Rugby \xE0 7',
		female: 'Joueuse de Rugby \xE0 7',
		full: 'Sport > Rugby > Rugby \xE0 7'
	},
	actor: {
		male: 'Com\xE9dien',
		female: 'Com\xE9dienne',
		full: 'Arts & M\xE9dia > Com\xE9dien'
	},
	adventurer: {
		male: 'Aventurier',
		female: 'Aventuri\xE8re',
		full: 'Expertise > Aventurier'
	},
	alpine_ski: {
		male: 'Skieur alpin',
		female: 'Skieuse alpine',
		full: 'Sport > Ski > Ski alpin'
	},
	american_football: {
		male: 'Footballeur am\xE9ricain',
		female: 'Footballeuse am\xE9ricaine',
		full: 'Sport > Football Am\xE9ricain'
	},
	animator: {
		male: 'Animateur',
		female: 'Animatrice',
		full: 'Arts & M\xE9dia > Animateur'
	},
	archery: {
		male: 'Tireur \xE0 l\'arc',
		female: 'Tireuse \xE0 l\'arc',
		full: 'Sport > Tir \xE0 l\'Arc'
	},
	architect: {
		male: 'Architecte',
		full: 'Expertise > Architecte'
	},
	army_officer: {
		male: 'Militaire de carri\xE8re',
		full: 'Expertise > Militaire de carri\xE8re'
	},
	art_and_media: 'Arts & M\xE9dia',
	artist: {
		male: 'Artiste',
		full: 'Arts & M\xE9dia > Artiste'
	},
	artistic_gymnastics: {
		male: 'Gymnaste artistique',
		full: 'Sport > Gymnastique > Artistique'
	},
	astronaut: {
		male: 'Astronaute',
		full: 'Expertise > Astronaute'
	},
	athletics: {
		male: 'Athl\xE8te',
		full: 'Sport > Athl\xE9tisme'
	},
	author: {
		male: 'Auteur',
		female: 'Auteure',
		full: 'Arts & M\xE9dia > Auteur'
	},
	automobile: {
		male: 'Pilote automobile',
		full: 'Sport > Automobile'
	},
	badminton: {
		male: 'Badiste',
		full: 'Sport > Badminton'
	},
	ball_dance: {
		male: 'Danseur de salon',
		female: 'Danseuse de salon',
		full: 'Musique & Danse > Danseur > Danse de salon'
	},
	band: {
		male: 'Groupe de Musique',
		full: 'Musique & Danse > Chanteur > Groupe'
	},
	basketball: {
		male: 'Basketteur',
		female: 'Basketteuse',
		full: 'Sport > Basketball'
	},
	biathlon: {
		male: 'Biathl\xE8te',
		full: 'Sport > Ski > Biathlon'
	},
	bmx: {
		male: 'Bmxeur',
		female: 'Bmxeuse',
		full: 'Sport > Cyclisme > BMX'
	},
	boxing: {
		male: 'Boxeur',
		female: 'Boxeuse',
		full: 'Sport > Boxe'
	},
	canoeying: {
		male: 'Cano\xEB-Kayakiste',
		full: 'Sport > Cano\xEB-Kayak'
	},
	ceo: {
		male: 'Chef d\'entreprise',
		full: 'Expertise > Chef d\'entreprise'
	},
	chef: {
		male: 'Chef',
		full: 'Gastronomie > Chef'
	},
	choreographer: {
		male: 'Chor\xE9graphe',
		full: 'Musique & Danse > Chor\xE9graphe'
	},
	classical_dance: {
		male: 'Danseur classique',
		female: 'Danseuse classique',
		full: 'Musique & Danse > Danseur > Danse classique'
	},
	clay_shooting: {
		male: 'Tireur de plateaux',
		female: 'Tireuse de plateaux',
		full: 'Sport > Tir > Plateaux'
	},
	climbing: {
		male: 'Grimpeur',
		female: 'Grimpeuse',
		full: 'Sport > Montagne et Escalade > Escalade'
	},
	coach: {
		male: 'Coach',
		full: 'Expertise > Coach'
	},
	composer: {
		male: 'Compositeur',
		female: 'Compositrice',
		full: 'Musique & Danse > Compositeur'
	},
	conductor: {
		male: 'Chef d\'orchestre',
		full: 'Musique & Danse > Chef d\'orchestre'
	},
	cost_guard: {
		male: 'Garde-c\xF4te',
		full: 'Sport > Sauvetage et Secourisme > C\xF4tier'
	},
	coxless_pairs: {
		male: 'Rameur (deux sans barreur)',
		female: 'Rameuse (deux sans barreur)',
		full: 'Sport > Aviron > Deux sans barreur'
	},
	creator: {
		male: 'Cr\xE9ateur',
		female: 'Cr\xE9atrice',
		full: 'Mode & Tendance > Cr\xE9ateur'
	},
	cross_country_running: {
		male: 'Coureur (cross)',
		female: 'Coureuse (cross)',
		full: 'Sport > Athl\xE9tisme > Cross Country'
	},
	cross_country_skiing: {
		male: 'Skieur de fond',
		female: 'Skieuse de fond',
		full: 'Sport > Ski > Ski de fond'
	},
	cycling: {
		male: 'Cycliste',
		full: 'Sport > Cyclisme'
	},
	dancer: {
		male: 'Danseur',
		female: 'Danseuse',
		full: 'Musique & Danse > Danseur'
	},
	director: {
		male: 'R\xE9alisateur',
		female: 'R\xE9alisatrice',
		full: 'Arts & M\xE9dia > R\xE9alisateur'
	},
	disabilities_sports: {
		male: 'HandiSportif',
		female: 'HandiSportive',
		full: 'Sport > HandiSport'
	},
	disabilities_alpine_ski: {
		male: 'Skieur alpin (Handisport)',
		female: 'Skieuse alpine (Handisport)',
		full: 'Sport > HandiSport > Ski alpin'
	},
	disabilities_athletics: {
		male: 'Athl\xE8te (Handisport)',
		full: 'Sport > HandiSport > Athl\xE9tisme'
	},
	disabilities_basketball: {
		male: 'Basketteur (Handisport)',
		female: 'Basketteuse (Handisport)',
		full: 'Sport > HandiSport > Basketball'
	},
	disabilities_cycling: {
		male: 'Cycliste (Handisport)',
		full: 'Sport > HandiSport > Cyclisme'
	},
	disabilities_kayaking: {
		male: 'Kayakiste (Handisport)',
		full: 'Sport > HandiSport > Kayak'
	},
	disabilities_nordic_ski: {
		male: 'Skieur nordique (Handisport)',
		female: 'Skieuse nordique (Handisport)',
		full: 'Sport > HandiSport > Ski nordique'
	},
	disabilities_pingpong: {
		male: 'Pongiste (Handisport)',
		full: 'Sport > HandiSport > Tennis de table'
	},
	disabilities_swimming: {
		male: 'Nageur (Handisport)',
		female: 'Nageuse (Handisport)',
		full: 'Sport > HandiSport > Natation'
	},
	disabilities_tennis: {
		male: 'Tennisman (Handisport)',
		female: 'Tenniswoman (Handisport)',
		full: 'Sport > HandiSport > Tennis'
	},
	disabilities_triathlon: {
		male: 'Triathl\xE8te (Handisport)',
		full: 'Sport > HandiSport > Triathlon'
	},
	diving: {
		male: 'Plongeur',
		female: 'Plongeuse',
		full: 'Sport > Natation > Plongeon'
	},
	dj: {
		male: 'DJ',
		full: 'Musique & Danse > DJ'
	},
	doctor: {
		male: 'M\xE9decin',
		full: 'Expertise > M\xE9decin'
	},
	economist: {
		male: 'Economiste',
		full: 'Expertise > Economiste'
	},
	editor: {
		male: 'Editeur',
		female: 'Editrice',
		full: 'Expertise > Editeur'
	},
	endurance: {
		male: 'Coureur (fond)',
		female: 'Coureuse (fond)',
		full: 'Sport > Automobile > Endurance'
	},
	english_boxing: {
		male: 'Boxeur (boxe anglaise)',
		female: 'Boxeuse (boxe anglaise)',
		full: 'Sport > Boxe > Anglaise'
	},
	expertise: 'Expertise',
	fashion_designer: {
		male: 'Fashion Designer',
		female: 'Fashion Designeuse',
		full: 'Mode & Tendance > Fashion Designer'
	},
	fencing: {
		male: 'Escrimeur',
		female: 'Escrimeuse',
		full: 'Sport > Escrime'
	},
	fighter_pilot: {
		male: 'Pilote de chasse',
		full: 'Expertise > Pilote de chasse'
	},
	fighting: {
		male: 'Lutteur',
		female: 'Lutteuse',
		full: 'Sport > Lutte'
	},
	figure_skating: {
		male: 'Patineur artistique',
		female: 'Patineuse artistique',
		full: 'Sport > Sports de Glace > Patinage artistique'
	},
	fim_actor: {
		male: 'Acteur de cin\xE9ma',
		female: 'Actrice de cin\xE9ma',
		full: 'Arts & M\xE9dia > Com\xE9dien > Film'
	},
	foil: {
		male: 'Fleurettiste',
		full: 'Sport > Escrime > Fleuret'
	},
	food_critic: {
		male: 'Critique gastronomique',
		full: 'Gastronomie > Critique gastronomique'
	},
	football: {
		male: 'Footballeur',
		female: 'Footballeuse',
		full: 'Sport > Football'
	},
	formula_1: {
		male: 'Pilote de Formule 1',
		full: 'Sport > Automobile > Formule 1'
	},
	formula_3000: {
		male: 'Pilote de Formule 3000',
		full: 'Sport > Automobile > Formule 3000'
	},
	free_flight: {
		male: 'Kitesurfeur',
		female: 'Kitesurfeuse',
		full: 'Sport > Vol Libre'
	},
	free_wrestling: {
		male: 'Lutteur (lutte libre)',
		female: 'Lutteuse (lutte libre)',
		full: 'Sport > Lutte > Libre'
	},
	freestyle_motobiking: {
		male: 'Pilote de moto freestyle',
		full: 'Sport > MotoCyclisme > Moto Freestyle'
	},
	freestyle_ski: {
		male: 'Skieur freestyle',
		female: 'Skieuse freestyle',
		full: 'Sport > Ski > Freestyle'
	},
	freewater_swimming: {
		male: 'Nageur en eau libre',
		female: 'Nageuse en eau libre',
		full: 'Sport > Natation > Eau libre'
	},
	furniture_designer: {
		male: 'Designer-mobilier',
		full: 'Mode & Tendance > Design meuble'
	},
	futurist: {
		male: 'Prospectiviste',
		full: 'Expertise > Prospectiviste'
	},
	gardener: {
		male: 'Jardinier',
		female: 'Jardini\xE8re',
		full: 'Expertise > Jardinier'
	},
	gastronomy: 'Gastronomie',
	geopolitical_scientist: {
		male: 'G\xE9opolitologue',
		full: 'Expertise > G\xE9opolitologue'
	},
	golf: {
		male: 'Golfeur',
		female: 'Golfeuse',
		full: 'Sport > Golf'
	},
	greco_roman_wrestling: {
		male: 'Lutteur (lutte greco romaine)',
		female: 'Lutteuse (lutte greco romaine)',
		full: 'Sport > Lutte > Greco romaine'
	},
	gymnastics: {
		male: 'Gymnaste',
		full: 'Sport > Gymnastique'
	},
	handball: {
		male: 'Handballeur',
		female: 'Handballeuse',
		full: 'Sport > Handball'
	},
	high_hurdle_race: {
		male: 'Athl\xE8te (haies hautes)',
		full: 'Sport > Athl\xE9tisme > Haies hautes'
	},
	hiphop_dance: {
		male: 'Danseur hip-hop',
		female: 'Danseuse hip-hop',
		full: 'Musique & Danse > Danseur > Danse hip-hop'
	},
	hockey: {
		male: 'Joueur de hockey',
		female: 'Joueuse de hockey',
		full: 'Sport > Hockey'
	},
	horse_riding: {
		male: 'Cavalier',
		female: 'Cavali\xE8re',
		full: 'Sport > Equitation'
	},
	humorist: {
		male: 'Humoriste',
		full: 'Arts & M\xE9dia > Humoriste'
	},
	ice_dancing: {
		male: 'Danseur sur glace',
		female: 'Danseuse sur glace',
		full: 'Sport > Sports de Glace > Danse sur glace'
	},
	ice_sports: {
		male: 'Sportif de glace',
		female: 'Sportive de glace',
		full: 'Sport > Sports de Glace'
	},
	illustrator: {
		male: 'Dessinateur',
		female: 'Dessinatrice',
		full: 'Arts & M\xE9dia > Dessinateur'
	},
	imitator: {
		male: 'Imitateur',
		female: 'Imitatrice',
		full: 'Arts & M\xE9dia > Humoriste > Imitateur'
	},
	influencer: {
		male: 'Influenceur',
		female: 'Influenceuse',
		full: 'Influenceur'

	},
	influencer_global: {
		male: 'Influenceur (global)',
		female: 'Influenceuse',
		full: 'Influenceur > Global'
	},
	interior_designer: {
		male: 'Designer d\'int\xE9rieur',
		full: 'Mode & Tendance > Design d\'int\xE9rieur'
	},
	interpretor: {
		male: 'Interpr\xE8te',
		full: 'Musique & Danse > Interpr\xE8te'
	},
	jet_ski: {
		male: 'Pilote de jet ski',
		full: 'Sport > Jet Ski'
	},
	jockey: {
		male: 'Jockey',
		full: 'Sport > Equitation > Jockey'
	},
	journalist: {
		male: 'Journaliste',
		full: 'Arts & M\xE9dia > Journaliste'
	},
	judo: {
		male: 'Judoka',
		full: 'Sport > Judo'
	},
	kayaking: {
		male: 'Kayakiste',
		full: 'Sport > Kayak'
	},
	lawyer: {
		male: 'Avocat',
		female: 'Avocate',
		full: 'Expertise > Avocat'
	},
	licence: {
		full: 'Licence/Marque',
		male: 'Licence/Marque'
	},
	line_racing: {
		male: 'Kayakiste (course en ligne)',
		full: 'Sport > Cano\xEB-Kayak > Course en ligne'
	},
	long_jump: {
		male: 'Athl\xE8te (saut en longueur)',
		full: 'Sport > Athl\xE9tisme > Saut en longueur'
	},
	longboard: {
		male: 'Longboardeur',
		female: 'Longboardeuse',
		full: 'Sport > Surf > Longboard'
	},
	low_hurdle_race: {
		male: 'Athl\xE8te (haies basses)',
		full: 'Sport > Athl\xE9tisme > Haies basses'
	},
	magician: {
		male: 'Magicien',
		female: 'Magicienne',
		full: 'Arts & M\xE9dia > Magicien'
	},
	match_racing: {
		male: 'Navigateur (match racing)',
		female: 'Navigatrice (match racing)',
		full: 'Sport > Voile > Match racing'
	},
	medium_distance_running: {
		male: 'Coureur (demi-fond)',
		female: 'Coureuse (demi-fond)',
		full: 'Sport > Athl\xE9tisme > Demi-fond'
	},
	model: {
		male: 'Mannequin',
		full: 'Mode & Tendance > Mannequin'
	},
	modern_dance: {
		male: 'Danseur moderne',
		female: 'Danseuse moderne',
		full: 'Musique & Danse > Danseur > Danse moderne'
	},
	modern_pentathlon: {
		male: 'Athl\xE8te (pentathlon moderne)',
		full: 'Sport > Pentathlon Moderne'
	},
	moto_cross: {
		male: 'Pilote de moto cross',
		full: 'Sport > MotoCyclisme > Moto Cross'
	},
	motocycling: {
		male: 'Pilote de moto',
		full: 'Sport > MotoCyclisme'
	},
	mountain_biking: {
		male: 'Pilote de VTT',
		full: 'Sport > Cyclisme > VTT'
	},
	mountains_and_climbing: {
		male: 'Sportif de montagne',
		female: 'Sportive de montagne',
		full: 'Sport > Montagne et Escalade'
	},
	multisport_raid: {
		male: 'Raideur multisports',
		female: 'Raideuse multisports',
		full: 'Sport > Montagne et Escalade > Raid MultiSports'
	},
	music_and_dancing: 'Musique & Danse',
	musician: {
		male: 'Musicien',
		female: 'Musicienne',
		full: 'Musique & Danse > Musicien'
	},
	nordic_combined: {
		male: 'Skieur (combin\xE9 nordique)',
		female: 'Skieuse (combin\xE9 nordique)',
		full: 'Sport > Ski > Combin\xE9 nordique'
	},
	nordic_ski: {
		male: 'Skieur nordique',
		female: 'Skieuse nordique',
		full: 'Sport > Ski > Ski nordique'
	},
	ocean_racing: {
		male: 'Navigateur (course au large)',
		female: 'Navigatrice (course au large)',
		full: 'Sport > Voile > Course au large'
	},
	oenologist: {
		male: '\u0152nologue',
		full: 'Gastronomie > \u0152nologue'
	},
	orienteering_race: {
		male: 'Coureur (course d\'orientation)',
		female: 'Coureuse (course d\'orientation)',
		full: 'Sport > Course d\'orientation'
	},
	other_athletics: {
		male: 'Athl\xE8te (autres)',
		full: 'Sport > Athl\xE9tisme > Autres'
	},
	painter: {
		male: 'Peintre',
		full: 'Arts & M\xE9dia > Peintre'
	},
	philosopher: {
		male: 'Philosophe',
		full: 'Expertise > Philosophe'
	},
	photographer: {
		male: 'Photographe',
		full: 'Arts & M\xE9dia > Photographe'
	},
	pingpong: {
		male: 'Pongiste',
		full: 'Sport > HandiSport > Tennis de table'
	},
	pistol_shooting: {
		male: 'Tireur au pistolet',
		female: 'Tireuse au pistolet',
		full: 'Sport > Tir > Pistolet'
	},
	pole_vaulting: {
		male: 'Perchiste',
		full: 'Sport > Athl\xE9tisme > Perche'
	},
	political_scientist: {
		male: 'Politologue',
		full: 'Expertise > Politologue'
	},
	unicorn: 'Politique',
	politics: {
		male: 'Politicien',
		female: 'Politicienne',
		full: 'Politiques'
	},
	other: 'Autre',
	polo: {
		male: 'Joueur de polo',
		female: 'Joueuse de polo',
		full: 'Sport > Equitation > Polo'
	},
	pool_swimming: {
		male: 'Nageur (bassin)',
		female: 'Nageuse',
		full: 'Sport > Natation > Bassin'
	},
	professor: {
		male: 'Professeur',
		female: 'Professeure',
		full: 'Expertise > Professeur'
	},
	race_walking: {
		male: 'Athl\xE8te (marche athl\xE9tique)',
		full: 'Sport > Athl\xE9tisme > Marche athl\xE9tique'
	},
	radio: {
		male: 'Animateur radio',
		female: 'Animatrice radio',
		full: 'Arts & M\xE9dia > Animateur > Radio'
	},
	rally: {
		male: 'Pilote de rallye',
		full: 'Sport > Automobile > Rallye'
	},
	rescue_and_first_aid: {
		male: 'Sauveteur',
		female: 'Sauveteuse',
		full: 'Sport > Sauvetage et Secourisme'
	},
	road_cycling: {
		male: 'Cycliste sur route',
		full: 'Sport > Cyclisme > Route'
	},
	rowing: {
		male: 'Rameur (aviron)',
		female: 'Rameuse (aviron)',
		full: 'Sport > Aviron'
	},
	rugby: {
		male: 'Rugbyman',
		female: 'Rugbywoman',
		full: 'Sport > Rugby'
	},
	running: {
		male: 'Athl\xE8te (course \xE0 pied)',
		full: 'Sport > Course d\'orientation > Course \xE0 pieds'
	},
	rythmic_gymnastics: {
		male: 'Gymnaste rythmique',
		full: 'Sport > Gymnastique > Rythmique'
	},
	saber: {
		male: 'Escrimeur (sabre)',
		female: 'Escrimeuse (sabre)',
		full: 'Sport > Escrime > Sabre'
	},
	sailing: {
		male: 'Navigateur',
		female: 'Navigatrice',
		full: 'Sport > Voile'
	},
	scientist: {
		male: 'Scientifique',
		full: 'Expertise > Scientifique'
	},
	shooting: {
		male: 'Tireur',
		female: 'Tireuse',
		full: 'Sport > Tir'
	},
	show_jumping: {
		male: 'Cavalier (saut d\'obstacles)',
		female: 'Cavali\xE8re (saut d\'obstacles)',
		full: 'Sport > Equitation > Saut d\'Obstacles'
	},
	singer: {
		male: 'Chanteur',
		female: 'Chanteuse',
		full: 'Musique & Danse > Chanteur'
	},
	ski_acrobatics: {
		male: 'Skieur acrobatique',
		female: 'Skieuse acrobatique',
		full: 'Sport > Ski > Ski Acrobatique'
	},
	ski_mountaineering: {
		male: 'Skieur et Alpiniste',
		female: 'Skieuse alpine',
		full: 'Sport > Montagne et Escalade > Ski-Alpinisme'
	},
	skiff: {
		male: 'Navigateur (skiff)',
		female: 'Navigatrice (skiff)',
		full: 'Sport > Aviron > Skiff'
	},
	skiing: {
		male: 'Skieur',
		female: 'Skieuse',
		full: 'Sport > Ski'
	},
	slalom: {
		male: 'Kayakiste (slalom)',
		full: 'Sport > Cano\xEB-Kayak > Slalom'
	},
	snorkelling: {
		male: 'Plongeur en apn\xE9e',
		female: 'Plongeuse en apn\xE9e',
		full: 'Sport > Etudes et Sports Sous-Marins > Plong\xE9e apn\xE9e'
	},
	snowboard: {
		male: 'Snowboardeur',
		female: 'Snowboardeuse',
		full: 'Sport > Ski > Snowboard'
	},
	sociologist: {
		male: 'Sociologue',
		full: 'Expertise > Sociologue'
	},
	solo: {
		male: 'Chanteur solo',
		female: 'Chanteuse solo',
		full: 'Musique & Danse > Chanteur > Solo'
	},
	speaker: {
		male: 'Conf\xE9rencier',
		female: 'Conf\xE9renci\xE8re',
		full: 'Expertise > Conf\xE9rencier'
	},
	speed_skating: {
		male: 'Patineur de vitesse',
		female: 'Patineuse de vitesse',
		full: 'Sport > Sports de Glace > Vitesse / short-track'
	},
	sports: {
		male: 'Sportif',
		female: 'Sportive',
		full: 'Sport'
	},
	sprint_race: {
		male: 'Sprinteur',
		female: 'Sprinteuse',
		full: 'Sport > Athl\xE9tisme > Sprint'
	},
	squash: {
		male: 'Joueur de squash',
		female: 'Joueuse de squash',
		full: 'Sport > Squash'
	},
	surf_boat: {
		male: 'Sauveteur (surfboat)',
		female: 'Sauveteuse (surfboat)',
		full: 'Sport > Sauvetage et Secourisme > SurfBoat'
	},
	surfing: {
		male: 'Surfeur',
		female: 'Surfeuse',
		full: 'Sport > Surf'
	},
	swimming: {
		male: 'Nageur',
		female: 'Nageuse',
		full: 'Sport > Natation'
	},
	sword: {
		male: 'Ep\xE9iste',
		full: 'Sport > Escrime > Ep\xE9e'
	},
	synchromized_swimming: {
		male: 'Nageur (natation synchronis\xE9e)',
		female: 'Nageuse (natation synchronis\xE9e)',
		full: 'Sport > Natation > Synchronis\xE9e'
	},
	taekwondo: {
		male: 'Taekwondoka',
		full: 'Sport > Taekwondo'
	},
	target_shooting: {
		male: 'Tireur sur cible',
		female: 'Tireuse sur cible',
		full: 'Sport > Tir \xE0 l\'Arc > Tir sur Cible'
	},
	tennis: {
		male: 'Tennisman',
		female: 'Tenniswoman',
		full: 'Sport > Tennis'
	},
	thai_boxing: {
		male: 'Boxeur (boxe tha\xEFlandaise)',
		female: 'Boxeuse (boxe tha\xEFlandaise)',
		full: 'Sport > Boxe > Tha\xEFlandaise'
	},
	theatre_actor: {
		male: 'Com\xE9dien (th\xE9\xE2tre)',
		female: 'Com\xE9dienne (th\xE9\xE2tre)',
		full: 'Arts & M\xE9dia > Com\xE9dien > Th\xE9\xE2tre'
	},
	track_cycling: {
		male: 'Cycliste sur piste',
		full: 'Sport > Cyclisme > Piste'
	},
	track_race: {
		male: 'Coureur sur route',
		female: 'Coureuse sur route',
		full: 'Sport > Athl\xE9tisme > Course sur route'
	},
	trail: {
		male: 'Traileur',
		female: 'Traileuse',
		full: 'Sport > Montagne et Escalade > Trail'
	},
	trends_and_fashion: 'Mode & Tendance',
	triathlon: {
		male: 'Triathl\xE8te',
		full: 'Sport > Triathlon'
	},
	triple_jump: {
		male: 'Athl\xE8te (triple saut)',
		full: 'Sport > Athl\xE9tisme > Triple saut'
	},
	tv: {
		male: 'Animateur t\xE9l\xE9',
		female: 'Animatrice t\xE9l\xE9',
		full: 'Arts & M\xE9dia > Animateur > T\xE9l\xE9vision'
	},
	underwater_sports_and_studies: {
		male: 'Plongeur (\xE9tude et sports sous-marins)',
		female: 'Plongeuse',
		full: 'Sport > Etudes et Sports Sous-Marins'
	},
	volleyball: {
		male: 'Volleyeur',
		female: 'Volleyeuse',
		full: 'Sport > Volley-ball'
	},
	water_polo: {
		male: 'Joueur de water polo',
		female: 'Joueuse de water polo',
		full: 'Sport > Natation > Water polo'
	},
	water_ski: {
		male: 'Skieur nautique',
		female: 'Skieuse nautique',
		full: 'Sport > Ski nautique'
	},
	weight_lifting: {
		male: 'Halt\xE9rophile',
		full: 'Sport > Halt\xE9rophilie'
	},
	windsurfing: {
		male: 'V\xE9liplanchiste',
		full: 'Sport > Voile > Planche \xE0 voile'
	},
	writer: {
		male: 'Ecrivain',
		female: 'Ecrivaine',
		full: 'Arts & M\xE9dia > Auteur > Ecrivain'
	},
	youtuber: {
		male: 'Vid\xE9aste',
		full: 'Influenceur > Vid\xE9aste'
	},
	blogger: {
		male: 'Blogueur',
		female: 'Blogueuse',
		full: 'Influenceur > Blogueur'
	},
	'kickboxer': {
		male: 'Kickboxeur',
		female: 'Kickboxeuse',
		full: 'Sport > Boxe > Kickboxing'
	},
	'fitness_athlete': {
		male: 'Athl\xE8te (Fitness)',
		full: 'Sport > Fitness > Athl\xE8te'
	},
	'fitness_coach': {
		male: 'Coach (Fitness)',
		full: 'Sport > Fitness > Coach'
	},
	fitness: {
		male: 'Fitness',
		full: 'Sport > Fitness'
	},
	matador: {
		male: 'Matador',
		female: 'Matadora',
		full: 'Sport > Corrida'
	},
	urban_glide: {
		male: 'Rideur',
		female: 'Rideuse',
		full: 'Sport > Glisse Urbaine'
	},
	skateboard: {
		male: 'Skatebordeur',
		female: 'Skateboardeuse',
		full: 'Sport > Glisse Urbaine > Skateboard'
	},
	scooter: {
		male: 'Rideur (Trottinette)',
		female: 'Rideuse (Trottinette)',
		full: 'Sport > Glisse Urbaine > Trottinette'
	},

	roller_skating: {
		male: 'Rollerskateur',
		female: 'Rollerskateuse',
		full: 'Sport > Glisse Urbaine > Roller'
	},

	kitesurf: {
		male: 'Kite Surfeur',
		female: 'Kite Surfeuse',
		full: 'Sport > Voile > Kite Surf'
	},
	tatooist: {
		male: 'Tatoueur',
		female: 'Tatoueuse',
		full: 'Arts & M\xE9dia > Dessin > Tatouage'
	},

	comics_illustrator: {
		male: 'Illustrateur (BD)',
		female: 'Illustratrice (BD)',
		full: 'Arts & M\xE9dia > Dessin > BD'
	},

	street_artist: {
		male: 'Street Artist',
		full: 'Arts & M\xE9dia > Dessin > Street Art'
	},

	e_sport: {
		male: 'Gameur',
		female: 'Gameuse',
		full: 'Sport > E-Sport'
	},

	hairdresser: {
		male: 'Coiffeur',
		female: 'Coiffeuse',
		full: 'Expertise > Coiffure'
	},

	makeup_artist: {
		male: 'Make-up Artist',
		full: 'Expertise > Make-up Artist'
	},

	art_director: {
		male: 'Directeur Artistique',
		female: 'Directrice Artistique',
		full: 'Mode & Tendance > Direction Artistique'
	},

	producer: {
		male: 'Producteur',
		female: 'Productrice',
		full: 'Musique & Danse > Production'
	},

	cricket: {
		male: 'Joueur de Cricket',
		female: 'Joueuse de Cricket',
		full: 'Sport > Cricket'
	},

	baseball: {
		male: 'Joueur de Baseball',
		female: 'Joueuse de Baseball',
		full: 'Sports > Baseball'
	},

	fiction_character: {
		male: 'Personnage de Fiction',
		full: 'Autres > Personnage de Fiction'
	},
	event_or_wedding_planner: {
		male: 'Event / Wedding Planner',
		full: 'Arts & M\xE9dia > Event / Wedding Planner'
	},
	reality_tv: {
		male: 'T\xE9l\xE9-r\xE9alit\xE9',
		full: 'Arts & M\xE9dia > T\xE9l\xE9-r\xE9alit\xE9'
	},
	marketing_and_communication: {
		male: 'Marketing & Communication',
		full: 'Expertise > Marketing & Communication'
	},
	tech_and_ai: {
		male: 'Tech & IA',
		full: 'Expertise > Tech & IA'
	},
	management: {
		male: 'Management',
		full: 'Expertise > Management'
	}
};